import { createAppSelector } from '../root'
import type { RecoverableConfiguration, TruckConfiguration } from '../slices/configurationSlice'

export const selectOrderedTruckConfigurations = createAppSelector(
  [(state) => state.truckConfigurations.configurations],
  // this is almost poor form to cast to EnhancedConfigurationId, but the lookup will be either undefined or be a configuration
  (configurations): TruckConfiguration[] =>
    Object.values(configurations)
      .filter((x) => !!x)
      .toSorted((a, b) => a.sortOrder - b.sortOrder),
)

export const selectOrderedConfigurations = createAppSelector(
  [
    (state) => state.truckConfigurations.configurations,
    // (state) => state.truckConfigurations.pendingConfigurations,
    (state) => state.truckConfigurations.recoverableConfigurations,
  ],
  (configs, recoverableConfigs): (TruckConfiguration | RecoverableConfiguration)[] => {
    const configurations = Object.values(configs)
    const result: (TruckConfiguration | RecoverableConfiguration)[] = configurations.filter((x) => !!x)
    const withTabRecovery = import.meta.env.VITE_ENABLE_RECOVERY === 'true'
    if (!withTabRecovery) {
      return result
    }
    for (const recoverableConfig of recoverableConfigs) {
      if (result.some((x) => x.id === recoverableConfig.id)) {
        continue
      }
      result.push(recoverableConfig)
    }
    return result
  },
)
